/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from "react";
import {ConfirmOrderStatus } from "../../../Store/ConfirmOrder/types";
import SVG from "react-inlinesvg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { confirmLPOrderWithConsent, fetchConfirmLPOrder } from "../../../Store/ConfirmOrder/ConfirmOrderAPI";
import { toastError } from "../../../Methods/Helpers/ToastHelper";
import ConfirmOrderStatusHandler from "./Components/ConfirmOrderStatusHandler";
import SkeletonLoading from "../../../Components/Skeleton/SkeletonLoading";
import Button from "../../../Components/Button/Button";
import InputRadioCheckbox from "../../../Components/Forms/InputRadioCheckbox";

const orderInitialState: {order_id: string, consent: boolean, time_slot: Array<string>} = {
    order_id: "",
    consent: false,
    time_slot: ["10:00 AM to 12:00 PM"]
};

const ConfirmOrderByPatient = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [status, setStatus] = useState<ConfirmOrderStatus>(undefined);
    const [statusDetails, setStatusDetails] = useState<any>(undefined);
    const [orderDetails, setOrderDetails] = useState<any>();

    const formik = useFormik({
        validateOnMount: true,
        initialValues: orderInitialState,
        validationSchema: Yup.object({
            order_id: Yup.string().required("Order id is required"),
            consent: Yup.boolean().required("Please accept the to confirm the order").oneOf([true], "Order id is required"),
            time_slot: Yup.array().min(1, "Please select at least one time slot").of(Yup.string().required("Please select at least one time slot")).required("Please select at least one time slot"),
        }),
        onSubmit: (values) => {
            setIsLoading(true);
            handleOrderConfirm(values);
        },
    });

    console.log("formik.values", formik.values);

    useEffect(() => {
        if (id) {
            fetchOrderData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchOrderData = async () => {
        try {
            if (id) {
                setStatus(undefined);
                const response: any = await fetchConfirmLPOrder(id);
                if (response.success) {
                    let data = response.data[0];
                    console.log("data", data);
                    if (data.current_status === "Unconfirmed" || data.current_status === "WaitingImpilo" || data.current_status === "Hold") {
                        let tempData: any = {
                            firstname: data?.ecFirstName ?? undefined,
                            surname: data?.ecLastName ?? undefined,
                            leadEmail: data?.email ?? undefined,
                            childName: data?.child_name ?? undefined,
                            provider_tag: data?.provider_tag ?? "kiddohealth",
                            order_id: id,
                            consent: true,
                            time_slot: ["10:00 AM to 12:00 PM"]
                        }
                        formik.setValues({ ...tempData }, true);
                        setOrderDetails(tempData);
                        setIsLoading(false);
                    } else {
                        setStatus("INVALID_ORDER");
                        setStatusDetails(data.current_status);
                    }
                } else {
                    if (response.code === 404) {
                        setStatus("INVALID_ORDER_ID");
                    } else {
                        setStatus("RESPONSE_ERROR");
                    }
                }
            } else {
                setStatus("ORDER_ID_MISSING");
                setIsLoading(false);
            }
        } catch (error: any) {
            setIsLoading(false);
            setStatus("RESPONSE_ERROR");
            console.log("error", error.toString());
        }
    }

    const handleOrderConfirm = async (values?: any) => {
        try {
            if (id) {
                await confirmLPOrderWithConsent(id, values.consent, values.time_slot).then((resp: any) => {
                    setIsLoading(false);
                    if (resp.success) {
                        setStatus("ORDER_CONFIRMED");
                        setStatusDetails(orderDetails.childName);
                    } else {
                        toastError("Error in updating order, please try again")
                        setIsLoading(false);
                    }
                }).catch((error: any) => {
                    setIsLoading(false);
                    toastError(error.message || error.toString());
                });
                setIsLoading(false);
            } else {
                setStatus("ORDER_ID_MISSING");
                setIsLoading(false);
            }
        } catch (error: any) {
            setStatus("RESPONSE_ERROR");
            setIsLoading(false);
        }
    }

    return (
        <>
            {!status ? (
                <>
                    <div className="main-wrapper confirm-order-screens">
                        <div className="cards-wrap card-success">
                            <div className="card-body confirm-order-model">
                                <div className="header">
                                    <div className="logo mb-4">
                                        {" "}
                                        <SVG
                                            className="header-logo"
                                            src="Assets/Images/Logos/kiddo.svg"
                                            width="108"
                                            height="32"
                                        />{" "}
                                    </div>
                                    <div className="address-details-form">
                                        <form className="" noValidate onSubmit={(e) => {e.preventDefault();
                                            formik.handleSubmit();
                                            return false;
                                        }}>
                                            {isLoading ? (
                                                <>
                                                    {[1, 2, 3, 4, 5, 6].map(() => {
                                                        return (
                                                            <>
                                                                <div className="mb-2">
                                                                    <SkeletonLoading width={420} height={41} />
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                </>
                                            ) : (
                                                <>
                                                    <div className="mb-5">
                                                        <input type="hidden" name="order_id" value={formik.values.order_id} />
                                                        {formik.errors.order_id ? <label className="text-error">{formik.errors.order_id}</label> : ""}
                                                        <InputRadioCheckbox
                                                            name="consent"
                                                            label="I confirm my order and am agreed to be contacted by Kiddo Health Team"
                                                            id="consent"
                                                            inputValue={formik.values.consent}
                                                            onChange={formik.handleChange}
                                                            type="checkbox"
                                                            checked={formik.values.consent} />
                                                    </div>
                                                    <p className="h6">Please select a preferred time slot to be contacted by our team for device setup</p>
                                                    <div className="mb-5">
                                                        <InputRadioCheckbox
                                                            name="time_slot"
                                                            label="10:00 AM to 12:00 PM"
                                                            id="time_slot_1"
                                                            inputValue={"10:00 AM to 12:00 PM"}
                                                            onChange={formik.handleChange}
                                                            type="checkbox"
                                                            checked={formik.values.time_slot.includes("10:00 AM to 12:00 PM")} />
                                                            <InputRadioCheckbox
                                                            name="time_slot"
                                                            label="03:00 PM to 05:00 PM"
                                                            id="time_slot_2"
                                                            inputValue={"03:00 PM to 05:00 PM"}
                                                            onChange={formik.handleChange}
                                                            type="checkbox"
                                                            checked={formik.values.time_slot.includes("03:00 PM to 05:00 PM")} />
                                                            <InputRadioCheckbox
                                                            name="time_slot"
                                                            label="05:00 PM to 07:00 PM"
                                                            id="time_slot_3"
                                                            inputValue={"05:00 PM to 07:00 PM"}
                                                            onChange={formik.handleChange}
                                                            type="checkbox"
                                                            checked={formik.values.time_slot.includes("05:00 PM to 07:00 PM")} 
                                                            isError={formik.errors.time_slot ? true : false}
                                                            errorMessage={formik.errors.time_slot && formik.errors.time_slot.toString()}/>
                                                    </div>
                                                </>
                                            )}
                                            {isLoading ? (
                                                <>
                                                    <div className="cover-dropdown">
                                                        <SkeletonLoading width={420} height={46} />
                                                    </div>
                                                    <div className="btn-wrap">
                                                        <SkeletonLoading width={420} height={46} />
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <Button
                                                        btnType="submit"
                                                        customClass={`${!formik.isValid ? "btn-custom-disabled" : "btn-success"}`}
                                                        primary={true}
                                                        text={true}
                                                        label="Confirm Order"
                                                        disabled={!formik.isValid} />
                                                    {!formik.isValid && <label className="text-error mt-2 mx-2">Please provide your consent and select at least one time slot to proceed</label>}
                                                </>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <ConfirmOrderStatusHandler statusDetail={statusDetails} statusType={status} resendVerificationCode={() => {}} />
                </>
            )}
        </>
    );
};

export default ConfirmOrderByPatient;
